import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from './locales/en/translation.json';
import translationKR from './locales/kr/translation.json';

//Creating object with the variables of imported translation files
const resources = {
    kr: {
        translation: translationKR
    },
    en: {
        translation: translationEN
    }
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'kr',
        debug: false,
        resources,
        keySeparator: false,
        interpolation: {
            escapeValue: false
        },
        react: {
            useSuspense: false
        }
    });

export default i18n;
